import getRulePrice from "./getRulePrice"
import getAfterTripleAt from "../getStringAfterTripleAt";


/*const newPricingMock = {
	"price_model": "SECTION",
	"name": "test name",
	"price": 100,
	"discount": 30,
	"discount_type": "value",
	"discount_model": "discount_on_addition",
	"max_price_total": 1,
	"min_price_total": 2,
	"rule_config": {
		"rules": [
			{
				"tier": 1,
				"price_rule": "FIXED_AMOUNT",
				"value": 10
			},
			{
				"tier": 2,
				"price_rule": "PERCENTAGE_OF_BASE",
				"value": 100
			},
			{
				"tier": 3,
				"price_rule": "PERCENTAGE_OF_BASE",
				"value": 50
			}
		],
		"subsequent_rule": {
			"price_rule": "FIXED_AMOUNT",
			"value": 2
		}
	}
}*/

// --------------------------------------------------------
// Calculate price, eching count, and neatolabs cost for a single product
// --------------------------------------------------------
export default function priceCalculatorPerProduct(snap, productSKU) {
	
	// Get data from store
	const product = snap.product?.find(product => getAfterTripleAt(product.sku) === getAfterTripleAt(productSKU))
	const profile = product.productProfiles ||  product.product_profiles
	const sectionList = snap.sections.filter(section => getAfterTripleAt(section.product_sku) === getAfterTripleAt(productSKU));
	const elementList = snap.elements.filter(element =>
		sectionList.some(section => section.section_id === element.sectionId)
	);
	
	
	// Get pricing data from store
	const pricing = profile?.[0]?.pricing
	
	// Set element count
	const elementCount = elementList.length;
	
	// set group customization count
	const groupCount = Math.max(1, ...elementList.map(element=> element[element.type]?.list?.length || 0))
	
	// Set pricing model
	const pricingModel = pricing?.price_model || 'section';
	
	// Calculate eching sections count
	const echingList = elementList.reduce((acc, element) => {
		acc[element.sectionId] = (acc[element.sectionId] || 0) + 1;
		return acc;
	}, {});
	
	const echingCount = Object.keys(echingList).length;
	
	// Calculate price
	const itemRules = pricing?.rule_config?.rules;
	const itemCount = pricingModel === 'element' ? elementCount :
		pricingModel === 'section'? echingCount : elementCount ? 1 : 0;
	
	const subsequentRule = pricing?.rule_config?.subsequent_rule
	let calculatedPrice = 0
	
	
	
	for (let i = 0; i < itemCount; i++) {
		let rule = itemRules?.find(r=> r.tier === i+1)
		
		if (rule || subsequentRule?.price_rule) {
		
			if (!rule) rule = subsequentRule;
			const price = getRulePrice(
				pricing.price,
				rule
			)
			
			calculatedPrice += price
		} else {
			calculatedPrice += pricing.price
		}
	}
	
	if (pricing.min_price_total && calculatedPrice < pricing.min_price_total && elementCount) calculatedPrice = pricing.min_price_total;
	if (pricing.max_price_total && calculatedPrice > pricing.max_price_total && elementCount) calculatedPrice = pricing.max_price_total;
	
	
	// Calculate NeatoLabs cost
	const neatolabsCost = echingCount > 0 ? 5 + (echingCount - 1) : 0;
	
	return { price: calculatedPrice, echingCount, neatolabsCost, groupCount };
}
